import { Offcanvas } from "react-bootstrap";
import HelperService from "../../utility/HelperService";

interface Props {
  show: boolean;
  handleClose: () => void;
  data: any;
}

const ViewSubscriptionDetails = ({ show, handleClose, data }: Props) => {
  if (!data) return null;

  const txn = data.transaction || {};
  const billing = data.organization || txn.transactionBillingDetail || {};
  const plan = data.plan || {};
  const user = data.user || {};

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      className="offcanvas-custom"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Subscription Details</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <div className="card shadow-sm p-3">

          {/* TRANSACTION */}
          <h6 className="text-primary mb-3">Transaction Details</h6>
          <Detail label="Transaction Date" value={HelperService.dateFormatter(txn.createdAt)} />
          <Detail label="Subscription ID" value={txn.orderNo} />
          <Detail label="Payment ID" value={txn.paymentGatewayId} />
          <Detail label="Payment Method" value={txn.paymentMethod} />
          <Detail
            label="Payment Status"
            value={<span className={`badge ${txn.status === "PAID" ? "bg-success" : txn.status === "FAILED" ? "bg-danger" : "bg-warning"}`}>{txn.status}</span>}
          />

          <hr />

          {/* USER */}
          <h6 className="text-primary mb-3">User Details</h6>
          <Detail label="User Name" value={user.fullName} />
          <Detail label="User Email" value={user.email} />

          <hr />

          {/* PLAN */}
          <h6 className="text-primary mb-3">Plan Details</h6>
          <Detail label="Plan Name" value={plan.planName} />
          <Detail label="Subscription Start Date" value={HelperService.dateFormatter(data.startDate)} />
          <Detail label="Subscription End Date" value={HelperService.dateFormatter(data.endDate)} />

          <hr />

          {/* PAYMENT SUMMARY */}
          <h6 className="text-primary mb-3">Payment Summary</h6>
          <Detail label="Amount" value={`₹${txn.subTotal}`} />
          <Detail label="Discount" value={`₹${txn.discountedAmount}`} />
          <Detail label="Tax" value={`₹${txn.taxAmount}`} />
          <Detail label="Total Amount" value={`₹${txn.totalAmount}`} />

          <hr />

          {/* COMPANY */}
          <h6 className="text-primary mb-3">Company Details</h6>
          <Detail label="Company Name" value={billing.name || billing.companyName} />
          <Detail label="GST Number" value={billing.gstNumber} />
          <Detail
            label="Address"
            value={
              billing.address
            }
          />
          <Detail label="Country" value={billing.country?.name} />
          <Detail label="State" value={billing.state?.name} />
          <Detail label="City" value={billing.city?.name} />
          <Detail label="Zip Code" value={billing.pinCode || billing.zip} />
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

const Detail = ({ label, value }: { label: string; value: any }) => (
  <div className="row mb-2">
    <div className="col-5 text-muted">{label}</div>
    <div className="col-7 fw-semibold">{value || "-"}</div>
  </div>
);

export default ViewSubscriptionDetails;
